import React from 'react'

const SummaryContractualWizard = ({comment}:any) => {
  return (
    <div className='row'>
            <div className='col-md-12'>
                <h5 className='mb-3'>Summary </h5>
                <div className='d-flex gap-3'>
                    <p>Comments</p>
                    <p>{comment}</p>
                </div>
            </div>
        </div>
  )
}

export default SummaryContractualWizard